import axios from 'axios';

const BASE = '/api/v2/adminPanel/portCongestion';

// unwrap with response.data.data (check core-api response format)
function unwrap(response) {
    const body = response.data;
    if (body && Object.prototype.hasOwnProperty.call(body, 'data') && Array.isArray(body.errors)) {
        return body.data;
    }
    return body;
}

function get(url, params) {
    return axios({
        method: 'GET',
        url,
        params,
        withCredentials: true,
    }).then(unwrap);
}

function post(url, data) {
    return axios({
        method: 'POST',
        url,
        data,
        withCredentials: true,
    }).then(unwrap);
}

export function getCongestionMeta() {
    return get(`${BASE}/meta`);
}

export function getCongestionPort(portId) {
    return get(`${BASE}/ports/${portId}`);
}

export function getCongestionRuns(portId, params = {}) {
    return get(`${BASE}/ports/${portId}/congestion/runs`, params);
}

export function getCongestionRun(portId, runId) {
    return get(`${BASE}/ports/${portId}/congestion/scan/${runId}`);
}

export function estimateCongestionScan(portId, body) {
    return post(`${BASE}/ports/${portId}/congestion/scan/estimate`, body);
}

export function startCongestionScan(portId, body) {
    return post(`${BASE}/ports/${portId}/congestion/scan`, body);
}

export function startCongestionCalculate(portId, body) {
    return post(`${BASE}/ports/${portId}/congestion/calculate`, body);
}

export function getCongestionHexCells(portId, params = {}) {
    return get(`${BASE}/ports/${portId}/congestion/hex-cells`, params);
}

function cellSelectionBody(portId, cellAddresses, cellIds) {
    const data = {};
    if (portId) data.portId = portId;
    if (cellAddresses && cellAddresses.length) data.cellAddresses = cellAddresses;
    if (cellIds && cellIds.length) data.cellIds = cellIds;
    return data;
}

export function confirmCongestionHexCells(portId, cellAddresses, cellIds) {
    return post(`${BASE}/congestion/hex-cells/confirm`, cellSelectionBody(portId, cellAddresses, cellIds));
}

export function rejectCongestionHexCells(portId, cellAddresses, cellIds) {
    return post(`${BASE}/congestion/hex-cells/reject`, cellSelectionBody(portId, cellAddresses, cellIds));
}

export function deleteCongestionHexCells(portId, cellAddresses, cellIds) {
    return post(`${BASE}/congestion/hex-cells/delete`, cellSelectionBody(portId, cellAddresses, cellIds));
}

export function getCongestionZones(portId, zoneType) {
    return get(`${BASE}/ports/${portId}/congestion/zones`, zoneType ? { zoneType } : undefined);
}

export function createCongestionZone(portId, zoneType) {
    return post(`${BASE}/ports/${portId}/congestion/zones`, { zoneType });
}

export function renameCongestionZone(portId, zoneId, name) {
    return post(`${BASE}/ports/${portId}/congestion/zones/${zoneId}`, { name });
}

export function addCongestionCellsToZone(portId, zoneId, cellAddresses, cellIds) {
    return post(
        `${BASE}/ports/${portId}/congestion/zones/${zoneId}/cells`,
        cellSelectionBody(undefined, cellAddresses, cellIds),
    );
}

export function removeCongestionCellsFromZone(portId, zoneId, cellAddresses, cellIds) {
    return post(
        `${BASE}/ports/${portId}/congestion/zones/${zoneId}/cells/remove`,
        cellSelectionBody(undefined, cellAddresses, cellIds),
    );
}

export function mergeCongestionZones(portId, zoneIds) {
    return post(`${BASE}/ports/${portId}/congestion/zones/merge`, { zoneIds });
}

export function getCongestionStats(portId, params = {}) {
    return get(`${BASE}/ports/${portId}/congestion/stats`, params);
}

export function getCongestionHistogram(portId, params = {}) {
    return get(`${BASE}/ports/${portId}/congestion/histogram`, params);
}

export function getCongestionVesselTrack(mmsi, params = {}) {
    return get(`${BASE}/vessels/${mmsi}/congestion/track`, params);
}



// WEBPACK FOOTER //
// ./app/services/congestion.js